import React, { useEffect, useState } from "react";
import ApexCharts from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { apiGetTurnoverRateStats } from "../../api/dashboard";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNotificationService } from "../notification";
import { useAuth } from "../../hooks/useAuth";
import {
  dummyDataEmployeeTurnover,
  EmployeeTurnOverRate,
} from "../charts/chart";
import { formatDecimalNum } from "../../utils/url-id";
import { Box, Button, Skeleton, Stack, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Grid,
} from "@mui/material";
const periods = ["monthly", "yearly"];

// Updated color palette options - choose one of these combinations:

// Option 1: Professional Blue-Orange Gradient (Recommended)
const colors1 = [
  "#2F66F4", // dark blue (primary)
  "#FF6B35", // vibrant orange (better than yellow)
  "#10B981", // green
  "#EF4444", // red
  "#6366F1", // indigo
];

// Option 2: Cool Tones Palette
const colors2 = [
  "#2F66F4", // dark blue (primary)
  "#06B6D4", // cyan
  "#10B981", // green
  "#8B5CF6", // purple
  "#F59E0B", // amber (if you want to keep yellow)
];

// Option 3: Modern Corporate Palette
const colors3 = [
  "#2F66F4", // dark blue (primary)
  "#F97316", // orange
  "#059669", // emerald
  "#DC2626", // red
  "#7C3AED", // violet
];

// Option 4: Accessible High-Contrast Palette
const colors4 = [
  "#2F66F4", // dark blue (primary)
  "#EA580C", // orange-red
  "#16A34A", // green
  "#DC2626", // red
  "#9333EA", // purple
];

// const DashboardLineChart: React.FC = () => {
//   const theme = useTheme();
//   const isMedium = useResponsive("down", "md", "xl");
//   const isSmall = useResponsive("down", "sm", "xl");

//   const { showNotification } = useNotificationService();
//   const { token } = useAuth();

//   const [period, setPeriod] = useState<"monthly" | "yearly">("monthly");

//   const { data, isLoading, isError } = useQuery<EmployeeTurnOverRate>({
//     queryKey: ["turnover-stats", period],
//     queryFn: () => apiGetTurnoverRateStats(token, period),
//   });

//   if (isError) {
//     showNotification("Failed to fetch data", "error");
//   }

//   const stats: EmployeeTurnOverRate = data ?? dummyDataEmployeeTurnover;
//   const stripYear = (label: string) => {
//     return label.replace(/\s20\d{2}/, "");
//   };

//   const categories = stats.turnoverRates.map((rate) => stripYear(rate.month));

//   const lineSeries = [
//     {
//       name: "Turnover Rate",
//       type: "line",
//       data: stats.turnoverRates.map((rate) => formatDecimalNum(rate.turnoverRate)),
//     },
//   ];

//   const options: ApexOptions = {
//     chart: {
//       type: "line",
//       toolbar: { show: false },
//     },
//     tooltip: {
//       y: {
//         formatter: (val) => `${Math.round(val)}%`,
//       },
//     },
//     yaxis: {
//       title: { text: "Turnover Rate %" },
//       labels: { formatter: (val) => `${Math.round(val)}%` },
//     },
//     xaxis: { categories },
//     dataLabels: { enabled: false },
//     stroke: {
//       width: 3,
//       curve: "smooth",
//     },
//     grid: {
//       row: {
//         colors: ["#f9fafb", "transparent"],
//       },
//       borderColor: "#E5E7EB",
//       strokeDashArray: 4,
//     },
//     colors: [
//       "#2F66F4", // dark blue
//     ],
//   };

//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "space-around",
//       }}
//     >
//       <Stack
//         direction={"row"}
//         alignItems={"center"}
//         justifyContent={"space-between"}
//       >
//         <Typography
//           variant="subtitle2"
//           color={"neutral"}
//           sx={{
//             fontWeight: 700,
//             fontFamily: "Inter",
//             letterSpacing: "3%",
//             mb: 1,
//             mt: 2,
//             paddingX: 2,
//           }}
//         >
//           Employee Turnover Rate
//         </Typography>
//         {/* <Stack direction="row" spacing={2} mb={2}>
//           {periods.map((p) => (
//             <Button
//               key={p}
//               size="small"
//               variant={period === p ? "contained" : "text"}
//               onClick={() => setPeriod(p as "monthly" | "yearly")}
//               sx={{
//                 fontSize: 12,
//                 fontWeight: 700,
//                 height: 35,
//                 background: period === p ? "#2F66F4" : "none"
//               }}
//             >
//               {p.toUpperCase()}
//             </Button>
//           ))}
//         </Stack> */}
//       </Stack>

//       {isLoading || isError ? (
//         <Box sx={{ width: "96%", mx: "auto" }}>
//           {Array.from({ length: 4 }).map((_, idx) => (
//             <Skeleton
//               key={idx}
//               variant="rounded"
//               width={"100%"}
//               height={60}
//               sx={{ my: 2 }}
//             />
//           ))}
//         </Box>
//       ) : (
//         <ApexCharts
//           options={options}
//           series={lineSeries}
//           type="line"
//           height={350}
//         />
//       )}
//     </div>
//   );
// };

// export default DashboardLineChart;

// const DashboardBarChart: React.FC = () => {
//   const theme = useTheme();
//   const isMedium = useResponsive("down", "md", "xl");
//   const isSmall = useResponsive("down", "sm", "xl");
//   const { showNotification } = useNotificationService();
//   const { token } = useAuth();

//   const [period, setPeriod] = useState<"monthly" | "yearly">("monthly");
//   const { data, isLoading, isError } = useQuery<EmployeeTurnOverRate>({
//     queryKey: ["turnover-stats", period],
//     queryFn: () => apiGetTurnoverRateStats(token, period),
//   });

//   const stats: EmployeeTurnOverRate = data ?? dummyDataEmployeeTurnover;
//   const categories = stats.turnoverRates.map((rate) => rate.month);

//   const series = [
//     {
//       name: "Rate",
//       data: stats?.turnoverRates?.map((rate, id) =>
//         formatDecimalNum(rate.turnoverRate)
//       ),
//     },
//   ];
//   const lineSeries = [
//     {
//       name: "Turnover Rate",
//       type: "line",
//       data: stats.turnoverRates.map((rate) =>
//         formatDecimalNum(rate.turnoverRate)
//       ),
//     },
//   ];

//   // const options: ApexOptions = {
//   //   chart: {
//   //     type: "bar",
//   //     toolbar: {
//   //       show: false, // Disable the toolbar (menu)
//   //     },
//   //   },
//   //   xaxis: {
//   //     categories: stats?.turnoverRates?.map((rate, id) => rate.month),
//   //   },
//   //   title: {
//   //     text: "",
//   //     align: "left",
//   //   },
//   //   plotOptions: {
//   //     bar: {
//   //       horizontal: false,
//   //       columnWidth: isSmall ? "60%" : isMedium ? "40%" : "30%",
//   //     },
//   //   },
//   //   dataLabels: {
//   //     enabled: false,
//   //   },
//   //   stroke: {
//   //     show: true,
//   //     width: 2,
//   //     colors: ["transparent"],
//   //   },
//   //   grid: {
//   //     row: {
//   //       colors: ["#fff", "transparent"],
//   //       opacity: 0.5,
//   //     },
//   //     show: true,
//   //     borderColor: "#E7EAEE",
//   //     strokeDashArray: 4, // Make the grid lines dotted
//   //     position: "back",
//   //   },
//   //   colors: [`${theme.palette.primary.main}`, `${theme.palette.primary.light}`], // Add this line to set the colors for the series
//   // };
//   const options: ApexOptions = {
//     chart: {
//       type: "line",
//       toolbar: { show: false },
//     },
//     tooltip: {
//       y: {
//         formatter: (val) => `${Math.round(val)}%`,
//       },
//       x: {
//         formatter: (val) => {
//           // val is the X index — use it to look up the month-year label
//           return categories[val - 1] ?? ""; // fallback in case index is out of bounds
//         },
//       },
//     },
//     yaxis: {
//       title: { text: "Turnover Rate %" },
//       labels: { formatter: (val) => `${Math.round(val)}%` },
//     },
//     xaxis: {
//       categories,
//       labels: {
//         rotate: 0, // or -45/-90 if you want
//         formatter: (value) => {
//           const index = categories.indexOf(value); // Get index from categories
//           return index % 2 === 0 ? value : "";
//         },
//         style: {
//           fontSize: isSmall ? "10px" : "12px",
//         },
//       },
//     },

//     dataLabels: { enabled: false },
//     stroke: {
//       width: 3,
//       curve: "smooth",
//     },
//     grid: {
//       row: {
//         colors: ["#f9fafb", "transparent"],
//       },
//       borderColor: "#E5E7EB",
//       strokeDashArray: 4,
//     },
//     colors: [
//       "#2F66F4", // dark blue
//     ],
//   };
//   return (
//     <ApexCharts
//       options={options}
//       height={380}
//       series={lineSeries}
//       type="line"
//     />
//   );
// };

// export default DashboardBarChart;

interface MonthYearOption {
  value: string;
  label: string;
  date: string; // ISO date string (YYYY-MM-DD)
}

interface DateRange {
  startDate: MonthYearOption;
  endDate: MonthYearOption;
}

// Utility function to generate month-year options for the last 3 years
const generateMonthYearOptions = (): MonthYearOption[] => {
  const options: MonthYearOption[] = [];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  // Generate options for the last 3 years
  for (let yearOffset = 0; yearOffset < 3; yearOffset++) {
    const year = currentYear - yearOffset;

    // For current year, only go up to current month
    // For past years, include all 12 months
    const maxMonth = yearOffset === 0 ? currentMonth : 11;

    for (let month = maxMonth; month >= 0; month--) {
      const date = new Date(year, month, 1);
      const monthName = date.toLocaleString("default", { month: "short" });
      const label = `${monthName} ${year}`;
      const isoDate = `${year}-${String(month + 1).padStart(2, "0")}-01`;

      options.push({
        value: `${year}-${month}`,
        label: label,
        date: isoDate,
      });
    }
  }

  return options;
};

// Utility function to get the last day of a month
const getLastDayOfMonth = (year: number, month: number): string => {
  const lastDay = new Date(year, month + 1, 0).getDate();
  return `${year}-${String(month + 1).padStart(2, "0")}-${String(
    lastDay,
  ).padStart(2, "0")}`;
};

// Generate default date range (current fiscal year: July to June)
const getDefaultDateRange = (options: MonthYearOption[]): DateRange => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  // If we're in July-December, fiscal year is current year to next year
  // If we're in January-June, fiscal year is previous year to current year
  let fiscalStartYear, fiscalEndYear;

  if (currentMonth >= 6) {
    // July = 6, August = 7, etc.
    fiscalStartYear = currentYear;
    fiscalEndYear = currentYear + 1;
  } else {
    fiscalStartYear = currentYear - 1;
    fiscalEndYear = currentYear;
  }

  const startOption =
    options.find(
      (opt) => opt.value === `${fiscalStartYear}-6`, // July (month index 6)
    ) || options[options.length - 1]; // Fallback to oldest option

  const endOption =
    options.find(
      (opt) => opt.value === `${fiscalEndYear}-5`, // June (month index 5)
    ) || options[0]; // Fallback to newest option

  return {
    startDate: startOption,
    endDate: endOption,
  };
};

const DashboardBarChart: React.FC = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const { showNotification } = useNotificationService();

  // Generate month-year options
  const monthYearOptions = useMemo(() => generateMonthYearOptions(), []);

  // Set default date range
  const defaultRange = useMemo(
    () => getDefaultDateRange(monthYearOptions),
    [monthYearOptions],
  );
  const [dateRange, setDateRange] = useState<DateRange>(defaultRange);

  // Handle date range changes
  const handleStartDateChange = useCallback(
    (event: SelectChangeEvent<string>) => {
      const selectedValue = event.target.value;
      const selectedOption = monthYearOptions.find(
        (option) => option.value === selectedValue,
      );
      if (selectedOption) {
        setDateRange((prev) => ({
          ...prev,
          startDate: selectedOption,
        }));
      }
    },
    [monthYearOptions],
  );

  const handleEndDateChange = useCallback(
    (event: SelectChangeEvent<string>) => {
      const selectedValue = event.target.value;
      const selectedOption = monthYearOptions.find(
        (option) => option.value === selectedValue,
      );
      if (selectedOption) {
        setDateRange((prev) => ({
          ...prev,
          endDate: selectedOption,
        }));
      }
    },
    [monthYearOptions],
  );

  // Prepare API dates
  const apiStartDate = useMemo(() => {
    return dateRange.startDate.date;
  }, [dateRange.startDate]);

  const apiEndDate = useMemo(() => {
    const [year, month] = dateRange.endDate.value.split("-").map(Number);
    return getLastDayOfMonth(year, month);
  }, [dateRange.endDate]);

  // Query with date range
  const { data, isLoading, isError } = useQuery<EmployeeTurnOverRate>({
    queryKey: ["turnover-stats", apiStartDate, apiEndDate],
    queryFn: () =>
      apiGetTurnoverRateStats(
        `startDate=${apiStartDate}&endDate=${apiEndDate}`,
      ),
    enabled: !!apiStartDate && !!apiEndDate,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  const stats: EmployeeTurnOverRate = data ?? dummyDataEmployeeTurnover;
  const categories = stats.turnoverRates.map((rate) => rate.month);

  const lineSeries = [
    {
      name: "Turnover Rate",
      type: "line" as const,
      data: stats.turnoverRates.map((rate) =>
        formatDecimalNum(rate.turnoverRate),
      ),
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
      animations: {
        enabled: !isLoading,
      },
    },
    tooltip: {
      theme: theme.palette.mode,
      y: {
        formatter: (val) => `${Math.round(val)}%`,
      },
      x: {
        formatter: (val) => {
          return categories[val - 1] ?? "";
        },
      },
    },
    yaxis: {
      title: {
        text: "Turnover Rate %",
        style: {
          color: theme.palette.text.secondary,
        },
      },
      labels: {
        formatter: (val) => `${Math.round(val)}%`,
        style: {
          colors: theme.palette.text.secondary,
        },
      },
    },
    xaxis: {
      categories,
      labels: {
        rotate: 0,
        formatter: (value) => {
          const index = categories.indexOf(value);
          return index % 2 === 0 ? value : "";
        },
        style: {
          fontSize: isSmall ? "10px" : "12px",
          colors: theme.palette.text.secondary,
        },
      },
      title: {
        text: `${dateRange.startDate.label} - ${dateRange.endDate.label}`,
        style: {
          color: theme.palette.text.secondary,
        },
      },
    },

    dataLabels: { enabled: false },
    stroke: {
      width: 3,
      curve: "smooth",
    },
    grid: {
      row: {
        colors: ["#f9fafb", "transparent"],
      },
      borderColor: "#E5E7EB",
      strokeDashArray: 4,
    },
    colors: ["#2F66F4"],
    noData: {
      text: "No data available",
      align: "center",
      verticalAlign: "middle",
      style: {
        color: theme.palette.text.secondary,
      },
    },
  };

  return (
    <Box>
      {/* Date Range Selection */}
      <Box mb={3}>
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 700, px: 3, my: 3 }}>
            Employee Turnover Rate
          </Typography>
        </Box>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel id="start-date-select-label">Start Date</InputLabel>
              <Select
                labelId="start-date-select-label"
                value={dateRange.startDate.value}
                onChange={handleStartDateChange}
                label="Start Date"
                disabled={isLoading}
              >
                {monthYearOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel id="end-date-select-label">End Date</InputLabel>
              <Select
                labelId="end-date-select-label"
                value={dateRange.endDate.value}
                onChange={handleEndDateChange}
                label="End Date"
                disabled={isLoading}
              >
                {monthYearOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="text.secondary">
              Selected Range: {dateRange.startDate.label} to{" "}
              {dateRange.endDate.label}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Chart */}
      <ApexCharts
        options={options}
        height={340}
        series={lineSeries}
        type="line"
      />
    </Box>
  );
};

export default DashboardBarChart;
